/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Language } from './Language';
import {
    LanguageFromJSON,
    LanguageFromJSONTyped,
    LanguageToJSON,
    LanguageToJSONTyped,
} from './Language';
import type { UserIdentityProvider } from './UserIdentityProvider';
import {
    UserIdentityProviderFromJSON,
    UserIdentityProviderFromJSONTyped,
    UserIdentityProviderToJSON,
    UserIdentityProviderToJSONTyped,
} from './UserIdentityProvider';
import type { UserIdentityOrigin } from './UserIdentityOrigin';
import {
    UserIdentityOriginFromJSON,
    UserIdentityOriginFromJSONTyped,
    UserIdentityOriginToJSON,
    UserIdentityOriginToJSONTyped,
} from './UserIdentityOrigin';
import type { UserType } from './UserType';
import {
    UserTypeFromJSON,
    UserTypeFromJSONTyped,
    UserTypeToJSON,
    UserTypeToJSONTyped,
} from './UserType';

/**
 * 
 * @export
 * @interface UserDto
 */
export interface UserDto {
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    userId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    displayName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    surname?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    strongAuthenticationPhoneNumber?: string | null;
    /**
     * 
     * @type {UserIdentityOrigin}
     * @memberof UserDto
     */
    identityOrigin?: UserIdentityOrigin;
    /**
     * 
     * @type {UserIdentityProvider}
     * @memberof UserDto
     */
    identityProvider?: UserIdentityProvider;
    /**
     * 
     * @type {Array<any>}
     * @memberof UserDto
     */
    roleIds?: Array<any> | null;
    /**
     * 
     * @type {Array<any>}
     * @memberof UserDto
     */
    permissionIds?: Array<any> | null;
    /**
     * 
     * @type {UserType}
     * @memberof UserDto
     */
    userType?: UserType;
    /**
     * 
     * @type {boolean}
     * @memberof UserDto
     */
    isIdPortenValidated?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    derivedUserId?: string | null;
    /**
     * 
     * @type {Language}
     * @memberof UserDto
     */
    preferredLanguage?: Language;
}



/**
 * Check if a given object implements the UserDto interface.
 */
export function instanceOfUserDto(value: object): value is UserDto {
    return true;
}

export function UserDtoFromJSON(json: any): UserDto {
    return UserDtoFromJSONTyped(json, false);
}

export function UserDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserDto {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] === undefined ? undefined : json['userId'] === null ? null : json['userId'],
        'displayName': json['displayName'] === undefined ? undefined : json['displayName'] === null ? null : json['displayName'],
        'email': json['email'] === undefined ? undefined : json['email'] === null ? null : json['email'],
        'firstName': json['firstName'] === undefined ? undefined : json['firstName'] === null ? null : json['firstName'],
        'surname': json['surname'] === undefined ? undefined : json['surname'] === null ? null : json['surname'],
        'strongAuthenticationPhoneNumber': json['strongAuthenticationPhoneNumber'] === undefined ? undefined : json['strongAuthenticationPhoneNumber'] === null ? null : json['strongAuthenticationPhoneNumber'],
        'identityOrigin': json['identityOrigin'] == null ? undefined : UserIdentityOriginFromJSON(json['identityOrigin']),
        'identityProvider': json['identityProvider'] == null ? undefined : UserIdentityProviderFromJSON(json['identityProvider']),
        'roleIds': json['roleIds'] === undefined ? undefined : json['roleIds'] === null ? null : json['roleIds'],
        'permissionIds': json['permissionIds'] === undefined ? undefined : json['permissionIds'] === null ? null : json['permissionIds'],
        'userType': json['userType'] == null ? undefined : UserTypeFromJSON(json['userType']),
        'isIdPortenValidated': json['isIdPortenValidated'] == null ? undefined : json['isIdPortenValidated'],
        'derivedUserId': json['derivedUserId'] === undefined ? undefined : json['derivedUserId'] === null ? null : json['derivedUserId'],
        'preferredLanguage': json['preferredLanguage'] == null ? undefined : LanguageFromJSON(json['preferredLanguage']),
    };
}

export function UserDtoToJSON(json: any): UserDto {
    return UserDtoToJSONTyped(json, false);
}

export function UserDtoToJSONTyped(value?: UserDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'displayName': value['displayName'],
        'email': value['email'],
        'firstName': value['firstName'],
        'surname': value['surname'],
        'strongAuthenticationPhoneNumber': value['strongAuthenticationPhoneNumber'],
        'identityOrigin': UserIdentityOriginToJSON(value['identityOrigin']),
        'identityProvider': UserIdentityProviderToJSON(value['identityProvider']),
        'roleIds': value['roleIds'],
        'permissionIds': value['permissionIds'],
        'userType': UserTypeToJSON(value['userType']),
        'isIdPortenValidated': value['isIdPortenValidated'],
        'derivedUserId': value['derivedUserId'],
        'preferredLanguage': LanguageToJSON(value['preferredLanguage']),
    };
}

